module.exports = __webpack_public_path__ + "static/media/user_sample.70b4a5dc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/user_sample.JPG
// module id = 1404
// module chunks = 1